import { useEffect, useRef, useState } from 'react';
import { registerSW } from 'virtual:pwa-register';

export function PwaUpdatePrompt() {
  const [hasUpdate, setHasUpdate] = useState(false);
  const updateServiceWorkerRef = useRef<((reloadPage?: boolean) => Promise<void>) | null>(null);

  useEffect(() => {
    updateServiceWorkerRef.current = registerSW({
      immediate: true,
      onRegisteredSW: (_swScriptUrl, registration) => {
        void registration?.update();
      },
      onNeedRefresh: () => {
        setHasUpdate(true);
      },
    });
  }, []);

  if (!hasUpdate) return null;

  return (
    <div className="fixed inset-x-3 bottom-3 z-[80] rounded-2xl border border-amber-400/40 bg-[#0f1217] p-4 text-white shadow-2xl shadow-black/50 sm:left-auto sm:max-w-md">
      <p className="text-sm font-black">Dostępna jest nowa wersja ProWyceny.</p>
      <p className="mt-1 text-sm text-slate-300">Odśwież aplikację, kiedy skończysz wpisywać dane.</p>
      <button
        type="button"
        onClick={() => void updateServiceWorkerRef.current?.(true)}
        className="mt-3 min-h-12 w-full rounded-2xl bg-[#00e676] px-4 text-sm font-black text-black transition hover:bg-emerald-300"
      >
        Odśwież
      </button>
    </div>
  );
}
